// System issues data
const issuesData = [
  {
    id: 'S-001',
    type: 'Security',
    status: 'Open',
    description: 'Client-side Authorization',
    details: 'The system relies on client-side role checks using localStorage, which can be tampered with. This should be complemented with server-side authorization checks.'
  },
  {
    id: 'S-002',
    type: 'Security',
    status: 'Open',
    description: 'Permissive Backend Security Configuration',
    details: 'WebSecurityConfig has `.antMatchers("/**").permitAll()` which allows all requests without authentication. This means the system relies entirely on frontend routing for access control.'
  },
  {
    id: 'S-003',
    type: 'Security',
    status: 'Open',
    description: 'Incomplete Role Utilization',
    details: 'The system has 8 defined roles but the routing logic only uses a few of them. Some roles like PARTNER_ADMIN vs PARTNER_USER don\'t appear to have different routing rules.'
  },
  {
    id: 'S-004',
    type: 'Security',
    status: 'Open',
    description: 'JWT Token Validation',
    details: 'Comprehensive JWT validation in the RequestFilter class appears to be missing or incomplete.'
  },
  {
    id: 'S-005',
    type: 'Security',
    status: 'Open',
    description: 'Missing Method-Level Security',
    details: 'Backend API endpoints lack @PreAuthorize annotations for method-level security checks.'
  },
  {
    id: 'UI-001',
    type: 'UI',
    status: 'Open',
    description: 'WorkflowDetail.js Syntax Errors',
    details: 'The WorkflowDetail.js file has JSX syntax errors related to mismatched tags (Paper and CardContent) and improper Fragment usage.'
  },
  {
    id: 'UI-002',
    type: 'UI',
    status: 'Open',
    description: 'Inconsistent Role-Based UI Elements',
    details: 'UI components don\'t consistently check for user roles before rendering role-specific elements.'
  },
  {
    id: 'UI-003',
    type: 'UI',
    status: 'Open',
    description: 'Missing Loading States',
    details: 'Some components may not properly handle loading states during authentication checks.'
  },
  {
    id: 'L-001',
    type: 'Logic',
    status: 'Open',
    description: 'Inconsistent Role Checking',
    details: 'Different components use different patterns to check user roles, leading to potential inconsistencies.'
  },
  {
    id: 'L-002',
    type: 'Logic',
    status: 'Open',
    description: 'Missing Role Fallbacks',
    details: 'If a user\'s role is not recognized, the system may not handle this case gracefully.'
  },
  {
    id: 'L-003',
    type: 'Logic',
    status: 'Open',
    description: 'Workflow Role Permissions',
    details: 'The workflow system doesn\'t appear to have granular permissions based on user roles.'
  },
  {
    id: 'API-001',
    type: 'API',
    status: 'Open',
    description: 'Missing Role Validation in APIs',
    details: 'API endpoints should validate user roles server-side before processing requests.'
  },
  {
    id: 'API-002',
    type: 'API',
    status: 'Open',
    description: 'Token Refresh Mechanism',
    details: 'The system may need a token refresh mechanism to handle token expiration.'
  },
  {
    id: 'API-003',
    type: 'API',
    status: 'Open',
    description: 'Error Handling for Unauthorized Access',
    details: 'API responses for unauthorized access attempts could be improved with more detailed error information.'
  },
  {
    id: 'API-004',
    type: 'API',
    status: 'Open',
    description: 'Frontend-Backend API Path Mismatch',
    details: 'The frontend tries to access workflow data at `/api/workflows` while the backend exposes it at `/v1/api/workflows`. Currently using a public endpoint (`/v1/api/public/workflows`) as a workaround, but should be fixed to use proper authenticated endpoints.'
  },
  {
    id: 'W-001',
    type: 'Workflow',
    status: 'Open',
    description: 'Workflow Assignment Flow Using Public API',
    details: 'The workflow assignment process currently uses a public API endpoint (`/v1/api/public/workflows`) to fetch and display services, then assigns them. This implementation parses the workflow definition JSON to extract steps but should be updated to use authenticated endpoints with proper data structure.'
  },
  {
    id: 'D-001',
    type: 'Data',
    status: 'Open',
    description: 'Role Data Consistency',
    details: 'Ensure role data is consistently structured across the system.'
  },
  {
    id: 'D-002',
    type: 'Data',
    status: 'Open',
    description: 'User Role Assignment Validation',
    details: 'Validate that users are only assigned appropriate roles based on their user type.'
  }
];

export default issuesData;
